import { Typography, Container, Box, Paper } from '@mui/material';

const UnsubscribeSuccess = () => (
    <Container maxWidth="sm">
        <Paper elevation={3} sx={{ padding: 4, mt: 6 }}>
            <Box textAlign="center" py={6}>
                <Typography variant="h4" gutterBottom color="#e29c2e">
                    You’ve been unsubscribed
                </Typography>
                <Typography variant="body1" color="textSecondary">
                    Your preferences have been updated and you will no longer receive emails from us.
                </Typography>
            </Box>
        </Paper>
    </Container>
);

export default UnsubscribeSuccess;
